<template>
  <div class="lesson">

    <div class="title">个人信息</div>
    <div class="centerMain">
        <div class="content">
          <p><span>姓名：</span>{{info.name}}</p>
          <p><span>性别：</span>{{info.gender == 1 ? '男' : info.gender == 2 ? '女' : ''}}</p>
          <p><span>手机号：</span>{{info.mobile}}</p>
        </div>
        <div class="content">
          <p><span>所在单位:</span>{{info.remark}}</p>
          <p><span>省市区：</span>{{info.province_name}} - {{ info.city_name }} - {{ info.district_name}}</p>
        </div>
    </div>
    <div class="title">参与的培训项目</div>
     <el-table :data="trainList" >
        <el-table-column property="name" label="培训项目名称" min-width="200"></el-table-column>
        <el-table-column property="fen" label="课时学分" min-width="140" >
          <template slot-scope="scope">
            {{ scope.row.course_number }}课时，{{ scope.row.fen }}学分
          </template>
        </el-table-column>
        <el-table-column property="address" label="培训时间" min-width="180" >
          <template slot-scope="scope">
            {{ scope.row.start_time.slice(0,10) }} ~ {{ scope.row.end_time.slice(0,10) }}
          </template>
        </el-table-column>
        <el-table-column property="course_name" label="关联课程" min-width="140" ></el-table-column>
        <el-table-column property="address" label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button type="text" v-if="new Date().getTime() < new Date(scope.row.end_time).getTime()" @click="toStudy(scope.row)">点击学习</el-button>
            <el-button type="text" disabled v-else >已结束</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination  
        style="padding-top: 20px"
        :page-size="per_page"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
  </div>
</template>

<script>
export default {
  name: "lesson",
  data() {
    return {
      info:{},
      pageLoading: true,
      page: 1,
      per_page: 10,
      total: 0,
      trainList:[],
    };
  },
  async mounted() {
    this.info = JSON.parse(window.localStorage.getItem('user'))
    this.getTrain()
  },
  destroyed() {
  },
  computed: {
    plat() {
      return this.$store.state.plat_id;
    },
  },
  methods: {
    getTag(index) {
      this.tag = index;
    },
    async getTrain(){

      let res = await this.$api({
          method: 'get',
          url: '/api/px/train',
          data:{
            page: this.page,
            per_page:this.per_page
          }
       });
       if (res.code == 0) {
        this.trainList = res.data.data
        this.total = res.data.total
       }
    },
    toStudy(item){
      let url = '/'+this.$route.params.plat_type+'/detail?id='+item.discpline_id
      console.log(url)
      this.$router.push(url)
    },
 handleCurrentChange(val){
      this.page = val
      this.getTrain()
    },
    
    
  },
  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate");
    console.log(to);
    next();
  },
};
</script>

<style lang="scss" scoped>
.lesson {
  min-height: calc(100vh - 230px);
  overflow: hidden;
  font-family: "SourceHanSans";
  .title{
    
    font-size: 24px;
    color: #242424;
    font-weight: bold;
    border-bottom: 1px dashed #f0f0f0;
    padding-top: 30px;
    padding-bottom: 20px;
    width: 100%;
  }
  .centerMain{
    width: 1000px;
    margin: 30px auto 0;
    background: #f9f9f9;
    border-radius: 8px;
    padding: 30px;
    .content{
      flex: 1;
      p{
        color: #666666;
        font-size: 16px;
        line-height: 60px;
        span{
          color: #333333;
          display: inline-block;
          width: 106px;
        }
      }
      &:first-of-type p{
        width: 33.3%;
        display: inline-block;
      }
    }
    img{
      width: 124px;
      height: 173px;
      border-radius: 8px;
      overflow: hidden;
      object-fit: cover;
    }
  }
}
</style>

<style lang="scss">
body {
  background: #fff;
}
</style>
